export default __webpack_public_path__ + "img/contact-homepage.0bd9b58c.svg";